import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchWordListWrap from '../../views/searchWord/list/SearchWordListWrap';
import { searchWordActions } from '../../store/modules/searchWord';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
  SEARCH_WORD_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/searchWord/models';

class SearchWordListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    this.getList({
      searchOption: SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
      sortOption: SEARCH_WORD_LIST_SORT_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 검색 키워드 리스트 가져오기
   */
  getList = (data) => {
    const { getSearchWordList, searchWordList } = this.props;
    const { searchOption, sortOption, pagination } = searchWordList;

    getSearchWordList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   *  검색 키워드 리스트 엑셀 다운로드
   */
  getSearchWordListExcelDownload = () => {
    const { getSearchWordListExcelDownload, searchWordList } = this.props;
    const { searchOption, sortOption } = searchWordList;

    getSearchWordListExcelDownload({
      searchOption,
      sortOption,
    });
  };

  render() {
    const { searchWordList, setData } = this.props;

    return (
      <SearchWordListWrap
        searchWordList={searchWordList}
        setData={setData}
        getList={this.getList}
        getSearchWordListExcelDownload={this.getSearchWordListExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchWordList: state.searchWord.searchWordList,
  };
};

const mapDispatchToProps = {
  setData: searchWordActions.setData,
  getSearchWordList: searchWordActions.getSearchWordList,
  getSearchWordListExcelDownload: searchWordActions.getSearchWordListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchWordListContainer);
